export const DomException = 'DOMException'
export const ReferenceError = 'ReferenceError'
export const SyntaxError = 'SyntaxError'
export const TypeError = 'TypeError'
